import { render, staticRenderFns } from "./chooseShop.vue?vue&type=template&id=2dbef868&scoped=true"
import script from "./chooseShop.vue?vue&type=script&lang=js"
export * from "./chooseShop.vue?vue&type=script&lang=js"
import style0 from "./chooseShop.vue?vue&type=style&index=0&id=2dbef868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbef868",
  null
  
)

export default component.exports